// extracted by mini-css-extract-plugin
export default {"wrapper":"lU-z","availablePromoMessagesLabel":"mU-z","promoMessageList":"nU-z","promoMessage":"oU-z","appliedPromoMessage":"pU-z","promoMessageAmount":"qU-z"};